import { VoltageSpeedChargingAssessment, VoltageSpeedDashboardSample } from '../../voltage-with-speed.models';
import { getSpeedVoltagePoints } from '../speed-voltage-scatter/speed-voltage-scatter.utils';

function validMetric(value: unknown, max = Infinity): number | null {
  return typeof value === 'number' && Number.isFinite(value) && value >= 0 && value <= max ? value : null;
}

export function buildChargingStability(assessment: VoltageSpeedChargingAssessment | null, samples: VoltageSpeedDashboardSample[]) {
  const points = getSpeedVoltagePoints(samples);
  const average = points.length ? points.reduce((sum, point) => sum + point.voltage, 0) / points.length : null;
  const deviation = average == null ? null : Math.sqrt(points.reduce((sum, point) => sum + (point.voltage - average) ** 2, 0) / points.length);

  return {
    status: typeof assessment?.ChargingStatus === 'string' ? assessment.ChargingStatus.trim() : '',
    note: typeof assessment?.AssessmentNote === 'string' ? assessment.AssessmentNote.trim() : '',
    rows: [
      { label: 'میانگین ولتاژ هنگام حرکت', value: average, unit: 'V', digits: '1.2-2' },
      { label: 'انحراف معیار ولتاژ حرکت', value: deviation, unit: 'V', digits: '1.2-2' },
      { label: 'جهش‌های لحظه‌ای', value: validMetric(assessment?.TransientEpisodeCount), unit: '', digits: '1.0-0' },
      { label: 'نوسانات پایدار', value: validMetric(assessment?.PersistentEpisodeCount), unit: '', digits: '1.0-0' },
      { label: 'مجموع رویدادهای ولتاژ', value: validMetric(assessment?.EpisodeCount), unit: '', digits: '1.0-0' },
      { label: 'نمونه‌های موتور روشن', value: validMetric(assessment?.EngineOnSamples), unit: '', digits: '1.0-0' },
      { label: 'نمونه‌های قابل مقایسه', value: validMetric(assessment?.ComparableSamples), unit: '', digits: '1.0-0' },
      { label: 'نمونه‌های غیرعادی', value: validMetric(assessment?.AbnormalSamples), unit: '', digits: '1.0-0' },
      { label: 'درصد پوشش داده‌ها', value: validMetric(assessment?.CoveragePercent, 100), unit: '%', digits: '1.1-1' },
      { label: 'سهم نمونه‌های قابل مقایسه', value: validMetric(assessment?.ComparablePercent, 100), unit: '%', digits: '1.1-1' }
    ]
  };
}
